/**
 * DBCO-0028 - the `detail` of a ProblemDetails error body, which the BFF propagates from the domain
 * service (e.g. the nomination gate's 409 reason). Undefined when the error carries none.
 */
export const problemDetail = (error: unknown): string | undefined => {
  const detail = (error as { response?: { data?: { detail?: unknown } } } | null)?.response?.data
    ?.detail;
  return typeof detail === "string" && detail.trim() !== "" ? detail : undefined;
};

/** DBCO-0029 - the HTTP status of a failed BFF call, undefined when the error carries none. */
export const problemStatus = (error: unknown): number | undefined => {
  const status = (error as { response?: { status?: unknown } } | null)?.response?.status;
  return typeof status === "number" ? status : undefined;
};

/** DBCO-0029 - the specific reason a call was refused: the ProblemDetails `detail`, else its `title`. */
export const problemMessage = (error: unknown): string | undefined => {
  const detail = problemDetail(error);
  if (detail) {
    return detail;
  }
  const title = (error as { response?: { data?: { title?: unknown } } } | null)?.response?.data
    ?.title;
  return typeof title === "string" && title.trim() !== "" ? title : undefined;
};
